module.exports = __webpack_public_path__ + "img/te-21.a3ed39fa.png";